import React, {Component} from 'react';
import CircleIntroPopUp from "./CircleIntroPopUp";
import {authService} from "../../auth";
import CircleIntroItem from "./CircleIntroItem";
import OwlCarousel from 'react-owl-carousel';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


class CircleIntro extends Component {
    constructor(props) {
        super(props);
        let userData = authService.getUserDetailsFromLocalStorage();
        this.state = {
            userData: userData,
            circleList:[],
            eventSnippetPopUp: false
        }
    }

    handlePopUpModal=()=>{
        this.setState({
            eventSnippetPopUp: true
        }, () => {
            window.$('#circletoppostwrap').modal('show');
        })
    }

    handleEnoughModal=()=>{
        window.$('#enoughPopUp').modal('show');
    }
    hideEnoughModal=()=>{
        window.$('#enoughPopUp').modal('hide');
    }

    onCloseEventPopup = () => {
        window.$('#circletoppostwrap').modal('hide');
        this.setState({
            eventSnippetPopUp: false
        })
    }

    render() {
        return <div className="circleWhatWeDo">
            <h2 className="title">What we do</h2>
            { this.props.isCirclePostList === "Success!" && this.props.circleList && this.props.circleList.length === 0 ? 
            <div className="d-flex">
                {this.props.circleData && (this.props.circleData.memberType ==='Super Admin' || (this.props.circleData.memberType ==='Admin' && this.props.masterConfigData && this.props.masterConfigData.circleUserPermissionMetadata && this.props.masterConfigData.circleUserPermissionMetadata.canCircleIntroPostSend)) &&<a href="javascript:void(0)" className="btnaddnew" onClick={this.handlePopUpModal}><span><i className="iPhotos" /><strong>Add New</strong></span></a>}
                <div className="zdataWrap">
                    <div className="zdata">
                        <div className="imgbox"><img src="https://cdn.dscovr.com/images/whatWeDo_NullFiller.svg" alt="" /></div>
                        <div className="desc">
                            {this.props.circleData && (this.props.circleData.memberType ==='Super Admin' || this.props.circleData.memberType ==='Admin') ? <p>Update Community stories here with pictures and videos and let the world know your activities.</p>: <p>No stories updated</p>}
                            {this.props.circleData && (this.props.circleData.memberType ==='Super Admin' || (this.props.circleData.memberType ==='Admin' && this.props.masterConfigData && this.props.masterConfigData.circleUserPermissionMetadata && this.props.masterConfigData.circleUserPermissionMetadata.canCircleIntroPostSend)) && <p><a href="javascript:void(0)" onClick={this.handlePopUpModal}>Click to Add New</a></p>}
                        </div>
                    </div>
                </div>
            </div>  :<OwlCarousel
                id={"circleWhatWeDo"}
                autoWidth={true}                
                margin={12}
                items={1}
                loop={false}
                rewind={true}
                touchDrag={false} 
                nav={this.props.circleData && (this.props.circleData.memberType ==='Super Admin' || (this.props.circleData.memberType ==='Admin' && this.props.masterConfigData && this.props.masterConfigData.circleUserPermissionMetadata && this.props.masterConfigData.circleUserPermissionMetadata.canCircleIntroPostSend)) ? 
                    ((this.props.circleList?.length > 2 && window.innerWidth >= 1200) || (this.props.circleList?.length > 1 && window.innerWidth >= 545 && window.innerWidth <= 1199) || (this.props.circleList?.length >= 1 && window.innerWidth < 545) ? true : false) :
                    ((this.props.circleList?.length > 2 && window.innerWidth >= 870) || (this.props.circleList?.length > 1 && window.innerWidth <= 869) ? true : false)}
                navText= {["<i class='iArrow_Left'></i>", "<i class='iArrow_Right'></i>"]}
            >
                    {this.props.circleData && (this.props.circleData.memberType ==='Super Admin' || (this.props.circleData.memberType ==='Admin' && this.props.masterConfigData && this.props.masterConfigData.circleUserPermissionMetadata && this.props.masterConfigData.circleUserPermissionMetadata.canCircleIntroPostSend)) &&<div className="item">
                    {this.props.circleList && this.props.circleList.length < 5 ? <a href="javascript:void(0)" className="btnaddnew" onClick={this.handlePopUpModal}><span><i className="iPhotos" /><strong>Add New</strong></span></a> :
                        <a href="javascript:void(0)" className="btnaddnew" onClick={this.handleEnoughModal}><span><i className="iPhotos" /><strong>Add New</strong></span></a>}
                </div>}
                {this.props.circleList && this.props.circleList.map((data,index)=>{
                    return <CircleIntroItem circleData={this.props.circleData} data={data} key={data.id}
                                            getCirclePostList={this.props.getCirclePostList}
                                            masterConfigData={this.props.masterConfigData}/>
                })}
            </OwlCarousel>  }
            {this.state.eventSnippetPopUp && 
                <CircleIntroPopUp circleData={this.props.circleData} getCirclePostList={this.props.getCirclePostList} onCloseEventPopup={this.onCloseEventPopup} />
            }
            {/*Enough Modal Start*/}
            <div className="modal fade dgpopup confirmpop"
                 id={"enoughPopUp"} tabIndex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                                    aria-hidden="true">&times;</span></button>
                        <div className="confirm-popup-modal-body">You can upload upto five posts</div>
                        {/* <div className="modal-footer confirm-popup-modal-footer">
                            <button type="button" className="btn btn-primary"
                                    onClick={this.hideEnoughModal}>Ok
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
            {/*Enough Modal End*/}
        </div>

    }
}

export default CircleIntro;
